const _bibles: BibleReference[] = [
  {
    id: 'private-bible-kjv',
    name: 'King James Version',
    abbreviation: 'KJV',
    description: 'Protestant',
    source: 'private',
    isPublicDomain: true,
  },
  {
    id: 'a556c5305ee15c3f-01',
    name: 'Christian Standard Bible',
    abbreviation: 'CSB',
    description: 'Protestant',
    source: 'api.bible',
    copyrightNotice: '© 2017 Holman Bible Publishers. All rights reserved.',
    copyrightFull:
      'The Christian Standard Bible®, Copyright © 2017 by Holman Bible Publishers. Used by permission. Christian Standard Bible® and CSB® are federally registered trademarks of Holman Bible Publishers.',
    ipHolderUrl: 'https://csbible.com',
  },
  {
    id: 'private-bible-esv',
    name: 'English Standard Version',
    abbreviation: 'ESV',
    description: 'Protestant',
    source: 'private',
    copyrightNotice: '© 2001 Crossway. All rights reserved.',
    copyrightFull:
      'Scripture quotations are from the ESV® Bible (The Holy Bible, English Standard Version®), © 2001 by Crossway, a publishing ministry of Good News Publishers. ESV® Text Edition: 2016. The ESV text may not be quoted in any publication made available to the public by a Creative Commons license. The ESV may not be translated in whole or in part into any other language. Used by permission. All rights reserved.',
    ipHolderUrl: 'https://www.crossway.org',
  },
  {
    id: 'private-bible-web',
    name: 'World English Bible',
    abbreviation: 'WEB',
    description: 'Protestant',
    source: 'private',
    isPublicDomain: true,
    // The text is public domain, but the name is a trademark licensed only for
    // faithful copies of the translation published at worldenglish.bible.
    ipHolderUrl: 'https://worldenglish.bible',
  },
  {
    id: 'a761ca71e0b3ddcf-01',
    name: 'New American Standard Bible',
    abbreviation: 'NASB',
    description: 'Protestant',
    source: 'api.bible',
    copyrightNotice: '© 2020 The Lockman Foundation. All rights reserved.',
    copyrightFull:
      'New American Standard Bible®, Copyright © 1960, 1971, 1977, 1995, 2020 by The Lockman Foundation. All rights reserved. www.lockman.org',
    ipHolderUrl: 'https://www.lockman.org',
  },
  {
    id: '63097d2a0a2f7db3-01',
    name: 'New King James Version',
    abbreviation: 'NKJV',
    description: 'Protestant',
    source: 'api.bible',
    copyrightNotice: '© 1982 Thomas Nelson. All rights reserved.',
    copyrightFull:
      'Scripture taken from the New King James Version®. Copyright © 1982 by Thomas Nelson. Used by permission. All rights reserved.',
    ipHolderUrl: 'https://www.thomasnelson.com',
  },
  {
    id: 'd6e14a625393b4da-01',
    name: 'New Living Translation',
    abbreviation: 'NLT',
    description: 'Protestant',
    source: 'api.bible',
    copyrightNotice: '© 2015 Tyndale House Foundation. All rights reserved.',
    copyrightFull:
      'Holy Bible, New Living Translation, copyright © 1996, 2004, 2015 by Tyndale House Foundation. Used by permission of Tyndale House Publishers, Carol Stream, Illinois 60188. All rights reserved.',
    ipHolderUrl: 'https://www.tyndale.com',
  },
];

export const bibles = new Map(_bibles.map((b) => [b.id, b]));
// ESV is the default Bible version
export const defaultBible =
  _bibles.find((b) => b.id === 'private-bible-esv') || _bibles[0];

// Old bible ids from before the source swap / id rename (see issue #201).
// Installed apps running old bundled JS still send these; normalize inbound
// ids so their searches keep resolving to the migrated bibles + cached rows.
const BIBLE_ID_ALIASES: Record<string, BibleId> = {
  'private-bible-csb': 'a556c5305ee15c3f-01',
  'de4e12af7f28f599-02': 'private-bible-kjv',
};

export function resolveBibleId(id: string): BibleId {
  return (BIBLE_ID_ALIASES[id] ?? id) as BibleId;
}

export type BibleId =
  | 'a556c5305ee15c3f-01' // Christian Standard Bible
  | 'a761ca71e0b3ddcf-01' // New American Standard Bible 2020
  | '63097d2a0a2f7db3-01' // New King James Version
  | 'd6e14a625393b4da-01' // New Living Translation
  | 'private-bible-esv'
  | 'private-bible-web'
  | 'private-bible-kjv';

export type BibleReference = {
  id: BibleId;
  name: string;
  abbreviation: string;
  description: string;
  source: BibleSource;
  /** Whether this translation is public domain (exempt from copyright citation). */
  isPublicDomain?: boolean;
  /**
   * Copyright notice without the abbreviation, e.g. "© 2017 Holman Bible
   * Publishers. All rights reserved." Used to compose the in-context citation
   * and to burn the © line into generated images (gated bibles only).
   */
  copyrightNotice?: string;
  /** Full copyright statement shown on the copyright page (gated bibles only). */
  copyrightFull?: string;
  /** IP holder's website, linked from the copyright page. */
  ipHolderUrl?: string;
};

export type BibleSource = 'private' | 'api.bible';
